import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import GLightbox from 'glightbox';

import 'glightbox/dist/js/glightbox.min.js';
import "@popperjs/core";
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css';
import 'glightbox/dist/css/glightbox.min.css';
import "bootstrap" 

import 'font-awesome/css/font-awesome.min.css';
import './assets/css/reset.css'
import './assets/css/home.css'
import 'boxicons/dist/boxicons.js'
import 'boxicons/css/boxicons.min.css'
import './assets/css/base.css'

import AOS from 'aos';
import 'aos/dist/aos.css';

import VueWaypoint from 'vue-waypoint'

import 'swiper/swiper-bundle.min.css'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
let options = {
  fullscreenEl: false
};
Vue.use(preview, options)
Vue.use(preview)

//注册全局组件
import RetractList from '@/components/RetractList.vue';
import MainTitle from '@/components/MainTitle.vue';
import DescList from '@/components/DescList.vue';
import CardList from '@/components/CardList.vue';

Vue.component("RetractList", RetractList)
Vue.component("MainTitle", MainTitle)
Vue.component("DescList", DescList)
Vue.component("CardList", CardList)

AOS.init(
  {
    duration: 1000,
    easing: 'ease-in-out',
    once: true,
    mirror: false
  }
);

window.eventBus = new Vue();

Vue.config.productionTip = false
Vue.prototype.$GLightbox = GLightbox;
Vue.use(VueWaypoint)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
